export default __webpack_public_path__ + "static/media/bell.57233193.svg";